import { render, staticRenderFns } from "./settingsPosChangeBlock.vue?vue&type=template&id=fa2aea96&scoped=true&"
import script from "./settingsPosChangeBlock.vue?vue&type=script&lang=js&"
export * from "./settingsPosChangeBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa2aea96",
  null
  
)

export default component.exports